<template>
  <v-app-bar
    app
    density="compact">
    <img
      data-cy="main-logo"
      id="logo"
      alt="logo"
      src="../../../assets/images/logo.png"
      srcset="../../../assets/images/logo-2.png 2x ../../../assets/images/logo-3.png 3x"
      @click="mainStore.leaveSpace()" />

    <div
      v-if="axiosStore.savingInBackground"
      data-cy="background-saving">
      Elemente werden gespeichert, bitte verlassen sie die Seite nicht
    </div>

    <v-spacer> </v-spacer>

    <div
      v-if="mainStore.activeSpaceId"
      style="color: white">
      {{
        mainStore.calculationSpaces.find(
          (space) => space.id === mainStore.activeSpaceId
        )?.name
      }}
    </div>
    <v-spacer></v-spacer>
    <!-- <div v-if="isAllowedSupport">
      <v-btn @click="undefinedFunction()">Test Error</v-btn>
    </div> -->

    <!-- <div>
      <v-btn @click="checkData()">Test Data</v-btn>
    </div> -->

    <template v-slot:append>
      <v-toolbar-items>
        <span v-if="mainStore.copyData.id"
          >Kopiertes Element: {{ mainStore.copyData.name }}</span
        >
        <CalculationChecker v-if="isAllowedSupport" />
        <!-- <FormelChecker v-if="isAllowedSupport" /> -->
        <!-- <SupportAccess v-if="isAllowedSupport" /> -->
        <language-switcher color="white" />
        <user-menu />
      </v-toolbar-items>
    </template>
  </v-app-bar>
</template>

<script setup>
import CalculationChecker from "../tools/CalculationChecker.vue";
import FormelChecker from "../tools/FormelChecker.vue";
import LanguageSwitcher from "../tools/LanguageSwitcher.vue";
import SupportAccess from "../tools/SupportAccess.vue";
import UserMenu from "./UserMenu.vue";
import { computed } from "vue";
import { useAuthStore } from "@/stores/authStore";
import { useRouter } from "vue-router";
import { useSpaceStore } from "@/stores/spaceStore";
import { useMainStore } from "@/stores/mainStore";
import { useAxiosStore } from "@/stores/axiosStore";
import { toRaw } from "vue";

const authStore = useAuthStore();
const spaceStore = useSpaceStore();
const mainStore = useMainStore();
const axiosStore = useAxiosStore();

const router = useRouter();

const isAllowedSupport = computed(() =>
  authStore.superUser.includes(authStore.user?.email)
);

function checkData() {
  for (const [id, element] of Object.entries(spaceStore.calculationElements)) {
    if (element.children && element.children.includes(null)) {
      console.log("Element mit ID", id, "hat Null Kinder");
      console.log(toRaw(element.children));
      element.children = element.children.filter((child) => child !== null);
      spaceStore.updateElement(id, ["children"]);
    }
  }
}
</script>

<style scoped>
.v-toolbar {
  padding: 0 0 0 60px !important;
  background: linear-gradient(90deg, #0d0d0d 0%, #134d7d 100%) !important;
  box-shadow: none;
}

.v-toolbar-items {
  color: white;
  font-size: 16px;
}
</style>
